import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

interface SupportOptionProps {
	icon: React.ReactNode;
	title: string;
	description: string;
	buttonColor: string;
	children?: React.ReactNode;
}

const SupportCard: React.FC<SupportOptionProps> = ({
	icon,
	title,
	description,
	buttonColor,
	children,
}) => {
	return (
		<Card
			className="w-full h-full flex flex-col items-center p-2 shadow-sm rounded-lg"
			style={{
				borderTop: `4px solid ${
					buttonColor === 'blue'
						? '#3b82f6' // blue-500
						: buttonColor === 'purple'
							? '#a855f7' // purple-500
							: '#f97316' // orange-500
				}`,
				borderLeft: '1px solid #f0f0f0',
				borderRight: '1px solid #f0f0f0',
				borderBottom: '1px solid #f0f0f0',
			}}
		>
			<div className="flex flex-col items-center w-full">
				<div
					className={`flex items-center justify-center w-16 h-16 rounded-full mb-6 ${
						buttonColor === 'blue'
							? 'bg-blue-100'
							: buttonColor === 'purple'
								? 'bg-purple-100'
								: 'bg-orange-100'
					}`}
				>
					{icon}
				</div>

				<Title level={3} className="mb-2 text-center font-bold">
					{title}
				</Title>

				<Paragraph className="text-gray-600 text-center mb-6">{description}</Paragraph>

				{children}
			</div>
		</Card>
	);
};

export default SupportCard;
